import React from 'react';
import { Link } from 'react-router-dom';
import { renderMentions } from '../../lib/effeisbuck';

export default function MentionRenderer({ body, interactive = true }) {
  const parts = renderMentions(body);
  if (typeof parts === 'string') return <span>{parts}</span>;
  return (
    <span>
      {parts.map((p, idx) => {
        if (p.type === 'mention') {
          if (!interactive || !p.userId) {
            return (
              <span key={idx} className="wfm-mention-chip">
                @{p.name}
              </span>
            );
          }
          return (
            <Link
              key={idx}
              to={`/effeisbuck/profilo/${p.userId}`}
              className="wfm-mention-chip no-underline hover:underline"
            >
              @{p.name}
            </Link>
          );
        }
        return <span key={idx}>{p.value}</span>;
      })}
    </span>
  );
}
